export default __webpack_public_path__ + "static/media/control-1-white.d000f808.svg";